import React from 'react';

/*
 * TapeStrip
 * A restrained strip of translucent "washi" tape for holding paper down.
 * Decorative (aria-hidden). Reusable — the parent controls position, size
 * and rotation via `className`; `tone` picks the wash colour.
 */
const TONES = {
  cream: 'rgba(255, 249, 239, 0.62)',
  sage: 'rgba(168, 190, 154, 0.42)',
  blue: 'rgba(169, 199, 216, 0.42)',
};

function TapeStrip({ className = '', tone = 'cream' }) {
  const fill = TONES[tone] || TONES.cream;
  return (
    <span className={`tape-strip ${className}`} aria-hidden="true">
      <svg viewBox="0 0 120 34" preserveAspectRatio="none" focusable="false">
        <rect x="0" y="0" width="120" height="34" fill={fill} />
        {/* faint lengthwise sheen so the tape reads as translucent film */}
        <rect x="0" y="4" width="120" height="5" fill="rgba(255,255,255,0.25)" />
        <rect x="0" y="24" width="120" height="4" fill="rgba(56,68,62,0.06)" />
      </svg>
    </span>
  );
}

export default TapeStrip;
